import React from "react";
import "./journey_card.css";

function JourneyCard({ heading, text, containerStyle }) {
  return (
    <div style={containerStyle} className="journey-card">
      <p className="journey-card-heading"> {heading} </p>
      <p className="journey-card-text"> {text} </p>
    </div>
  );
}

export default JourneyCard;
